import Config, { Environment } from "@/libs/config"

const apis: Record<string, string> = {
  [Environment.Development]: "http://localhost:3002",
  [Environment.Homolog]: "https://dev-api.closecar.com.br",
  [Environment.Production]: "https://api.closecar.com.br",
}

export const baseApi = () => {
  const enviroment = Config.environment.base

  return apis[enviroment]
}
